import React, { useState } from 'react';
import axios from 'axios';
// Bước 1: Import địa chỉ API từ file config đã tạo
import API_BASE_URL from '../config'; 
import './UserManagement.css';

const UserManagement = () => {
    const [formData, setFormData] = useState({ fullname: '', email: '', password: '', role: 'student' });
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            const token = localStorage.getItem('token');
            
            await axios.post(`${API_BASE_URL}/api/admin/create-user`, formData, {
                headers: { Authorization: `Bearer ${token}` }
            });
            
            alert("🎉 Account created successfully!");
            setFormData({ fullname: '', email: '', password: '', role: 'student' }); 
        } catch (err) {
            alert(err.response?.data?.message || "Error creating account!");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="management-page">
            <div className="management-card">
                <div className="management-header">
                    <h2>👥 Create New Account</h2>
                    <p>Assign roles and grant access to the system</p>
                </div>
                
                <form onSubmit={handleSubmit} className="modern-form">
                    <div className="form-group">
                        <label>Full Name</label>
                        <input 
                            value={formData.fullname}
                            placeholder="e.g. Nguyen Van A" 
                            onChange={e => setFormData({...formData, fullname: e.target.value})} 
                            required 
                        />
                    </div>

                    <div className="form-group">
                        <label>Email Address</label>
                        <input 
                            type="email" 
                            value={formData.email}
                            placeholder="example@gmail.com" 
                            onChange={e => setFormData({...formData, email: e.target.value})} 
                            required 
                        />
                    </div>

                    <div className="form-group">
                        <label>Password</label>
                        <input 
                            type="password" 
                            value={formData.password}
                            placeholder="Minimum 6 characters" 
                            onChange={e => setFormData({...formData, password: e.target.value})} 
                            required 
                        />
                    </div>

                    <div className="form-group">
                        <label>Assign Role</label>
                       <select 
                            value={formData.role}
                            onChange={e => setFormData({...formData, role: e.target.value})}
                        >
                            <option value="student">Student (Học viên)</option>
                            <option value="user">User (Nhân viên nhập liệu)</option>
                            <option value="admin">Admin</option>
                        </select>
                    </div>

                    <button type="submit" className="submit-btn" disabled={loading}>
                        {loading ? "Processing..." : "Create Account"}
                    </button>
                </form>
            </div>
        </div>
    );
};

export default UserManagement;